module.exports = __webpack_public_path__ + "img/section4Logo5.838cd219.svg";